import iconClear from "@reactioncommerce/components/svg/iconClear";
import iconError from "@reactioncommerce/components/svg/iconError";
import iconValid from "@reactioncommerce/components/svg/iconValid";
import iconExpand from "@reactioncommerce/components/svg/iconExpand";
import iconPlus from "@reactioncommerce/components/svg/iconPlus";
import iconLock from "@reactioncommerce/components/svg/iconLock";
import spinner from "@reactioncommerce/components/svg/spinner";
import Accordion from "@reactioncommerce/components/Accordion/v1";
import AccordionFormList from "@reactioncommerce/components/AccordionFormList/v1";
import AddressBook from "@reactioncommerce/components/AddressBook/v1";
import AddressForm from "@reactioncommerce/components/AddressForm/v1";
import AddressReview from "@reactioncommerce/components/AddressReview/v1";
import BadgeOverlay from "@reactioncommerce/components/BadgeOverlay/v1";
import Button from "@reactioncommerce/catalyst/Button";
import CatalogGrid from "@reactioncommerce/components/CatalogGrid/v1";
import CatalogGridItem from "@reactioncommerce/components/CatalogGridItem/v1";
import Checkbox from "@reactioncommerce/components/Checkbox/v1";
import ErrorsBlock from "@reactioncommerce/components/ErrorsBlock/v1";
import Field from "@reactioncommerce/components/Field/v1";
import InlineAlert from "@reactioncommerce/components/InlineAlert/v1";
import { Link } from "./ui/components/link";
import MultiSelect from "@reactioncommerce/components/MultiSelect/v1";
import PhoneNumberInput from "@reactioncommerce/components/PhoneNumberInput/v1";
import Price from "@reactioncommerce/components/Price/v1";
import ProfileImage from "@reactioncommerce/components/ProfileImage/v1";
import ProgressiveImage from "@reactioncommerce/components/ProgressiveImage/v1";
import QuantityInput from "@reactioncommerce/components/QuantityInput/v1";
import RegionInput from "@reactioncommerce/components/RegionInput/v1";
import Select from "@reactioncommerce/components/Select/v1";
import SelectableItem from "@reactioncommerce/components/SelectableItem/v1";
import SelectableList from "@reactioncommerce/components/SelectableList/v1";
import ShopLogo from "@reactioncommerce/components/ShopLogo/v1";
import TextInput from "@reactioncommerce/components/TextInput/v1";
import * as iconComponents from "./theme/icons";

export default {
  ...iconComponents,
  Accordion,
  AddressBook,
  AddressForm,
  AccordionFormList,
  AddressReview,
  BadgeOverlay,
  Button,
  CatalogGrid,
  CatalogGridItem,
  Checkbox,
  ErrorsBlock,
  Field,
  iconClear,
  iconError,
  iconExpand,
  iconPlus,
  iconValid,
  iconLock,
  InlineAlert,
  Link,
  MultiSelect,
  PhoneNumberInput,
  Price,
  ProfileImage,
  ProgressiveImage,
  QuantityInput,
  RegionInput,
  Select,
  spinner,
  SelectableItem,
  SelectableList,
  ShopLogo,
  TextInput
};
